import React from 'react';
import AccordionDetails, { type AccordionDetailsProps } from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import styles from 'src/components/accordion-section/AccordionSectionDetails.module.css';

type Props = AccordionDetailsProps & {
    isEmpty?: boolean;
    emptyMessage?: React.ReactNode;
};

export default function AccordionSectionDetails({
    children,
    isEmpty = false,
    emptyMessage,
    ...props
}: Props) {
    return (
        <AccordionDetails
            classes={{
                root: styles.root,
            }}
            {...props}
        >
            {isEmpty ? (
                <div className={styles.empty}>
                    <Typography className={styles.emptyText}>
                        {emptyMessage}
                    </Typography>
                </div>
            ) : children}
        </AccordionDetails>
    );
}
